import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { StatusPageStore } from '@store';
import { StatusType } from '@vi-iot/client/index';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusComponent implements OnInit, OnDestroy {
  statusPageHeader: string;
  statusPageContent: string;

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    private statusPageStore: StatusPageStore,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.statusPageStore.getStatus();
    this.statusPageStore.status$.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((status) => {
      switch (status) {
        case StatusType.Major_Outage:
          this.statusPageHeader = 'OUTAGE_ERROR_PAGE.HEADER';
          this.statusPageContent = 'OUTAGE_ERROR_PAGE.CONTENT';
          break;
        case StatusType.Under_Maintenance:
          this.statusPageHeader = 'MAINTENANCE_ERROR_PAGE.HEADER';
          this.statusPageContent = 'MAINTENANCE_ERROR_PAGE.CONTENT';
          break;
        default:
          this.statusPageHeader = '';
          this.statusPageContent = '';
          this.router.navigate(['/installations']);
          break;
      }
      this.cdr.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
